module.exports = __webpack_public_path__ + "static/media/phone-handset.09341b74.svg";